import { createFileRoute } from "@tanstack/react-router";

import { AdminAdministratorsPage } from "@/components/admin/AdminAdministratorsPage";

export const Route = createFileRoute("/admin/administrators")({
  component: AdminAdministratorsPage,
});
